import DataObjectField from "@/utilities/classes/data-object-field";

const buildSiteObject = (vData, recordId) => {
    const fields = [
        new DataObjectField(recordId, 19),
        new DataObjectField(vData.Street1, 7),
        new DataObjectField(vData.Street2, 8),
        new DataObjectField(vData.City, 9),
        new DataObjectField(vData.State, 10),
        new DataObjectField(vData.Zip, 11),
        new DataObjectField(vData.Country, 12),
        new DataObjectField(vData.Owner[0], 56),
        new DataObjectField(vData.CensusTract, 57),
        new DataObjectField(vData.CouncilDistrict, 25),
        new DataObjectField(vData.OPANumber, 13),
        new DataObjectField(vData.AcqMethod, 58),
        new DataObjectField(vData.LotStructure, 59),
        new DataObjectField(vData.OtherAcqMethod, 60),
    ];

  const dataObject = {
    qdbapi: {
      udata: "SHARC_CREATE_SITE",
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      clist: "3",
      field: fields
    }
  };
  return dataObject;
};

export default buildSiteObject;